import React from 'react';
import { Link } from 'react-router-dom'

import moment from 'moment';

class Message extends React.Component {
    constructor (props) {
        super(props)
    }

    renderButtonText () {
        var text = '';
        if (!this.props.message.meta.read) {
            text = <span>Mark As Read</span>;
        } else {
            text = <span>Mark As Unread</span>;
        }
        return text;
    }

    getIcon () {
        switch (this.props.type) {
            case 'info': return <i className="fa fa-info-circle"></i>;
            case 'warning': return <i className="far fa-bell"></i>;
            case 'alert': return <i className="fa fa-exclamation-triangle"></i>;
            case 'error': return <i className="fa fa-times"></i>;
        }
    }

    render () {
        var read = this.props.message.meta.read ? 'read' : 'unread';
        return (
            <div className={'message ' + this.props.type + ' ' + read}>
                <div className="col-xs-12">
                    <header className="col-xs-12">
                        <div className={'icon ' + this.props.type}>
                            {this.getIcon()}
                        </div>
                        <div className="date">
                            {moment(this.props.message.msgDate, 'YYYY-MM-DD HH:mm:ss').format('MMM. DD, hh:mm a')}
                        </div>
                    </header>

                    <div className="col-xs-12">
                        <div className="message-body">
                            <p className="text">{this.props.message.msg}</p>
                            {this.renderEventLink()}
                        </div>
                    </div>
                </div>

                <div className=" message-actions">
                    <button className="btn btn-default" onClick={this.props.handleMarkAction.bind(null, this.props.type, this.props.message.msgID)}>
                        {this.renderButtonText()}
                    </button>
                </div>
            </div>
        );
    }

    renderEventLink () {
        if (this.props.message.eventID) {
            var linkText = this.props.message.eventID.split('_');
            linkText = linkText[linkText.length - 1];
            var link = '/events/?eventID=' + linkText;
            return (
                <p className="event-text">
                    <label>Event: </label> <code><Link to={link} title="Event">{linkText}</Link></code>
                </p>
            );
        }
    }
}

export default Message;
